// ------------------------------------------------------------
// 🧠 NEW labelWeeks() — clean, template-safe, distance-aware
// ------------------------------------------------------------
export function labelWeeks({ planWeeks, distance }) {
  const total = planWeeks.length;
  if (!total) return [];

  const CUTBACK_RHYTHM = distance === "5K" ? 3 : 4;

  // ----------------------------------------
  // 1️⃣ Determine taper length
  // ----------------------------------------
  let taper = 2; // Half + Marathon default
  if (["5K", "10K"].includes(distance)) taper = 1;

  const raceWeekIndex = total - 1;
  const taperStart = Math.max(1, raceWeekIndex - taper);

  // ----------------------------------------
  // 2️⃣ Determine onboarding length
  // Week 1 = Onboarding (always)
  // ----------------------------------------
  const onboardingCount = 1;

  // ----------------------------------------
  // 3️⃣ Determine how many BASE weeks we have
  // ----------------------------------------
  const trainingBlockWeeks = total - onboardingCount - taper;
  const baseCount = Math.max(0, trainingBlockWeeks - 12);

  // ----------------------------------------
  // 4️⃣ Main labeling pass
  // ----------------------------------------
  const labels = [];

  let buildCounter = 1;
  let globalWeek = 0;

  for (let i = 0; i < total; i++) {
    // Week 0 → Onboarding
    if (i === 0) {
      labels.push({ label: "Onboarding", meta: { phase: "onboarding" } });
      continue;
    }

    globalWeek++;

    // Taper → last N weeks before race
    if (i >= taperStart && i < raceWeekIndex) {
      labels.push({ label: "Taper", meta: { phase: "taper" } });
      continue;
    }

    // Race week
    if (i === raceWeekIndex) {
      labels.push({ label: "Race Week", meta: { phase: "race" } });
      continue;
    }

    // Base block
    if (i <= baseCount) {
      const baseIndex = i; // Base starts at Base 1
      if (baseIndex > 0 && baseIndex % CUTBACK_RHYTHM === 0) {
        labels.push({
          label: "Cutback",
          meta: { phase: "base-cutback" },
        });
      } else {
        labels.push({
          label: `Base ${baseIndex}`,
          meta: { phase: "base" },
        });
      }
      continue;
    }

    // Build + Cutback rhythm
    const idxIntoBuild = i - (baseCount + onboardingCount);

    if (idxIntoBuild > 0 && idxIntoBuild % CUTBACK_RHYTHM === 0) {
      labels.push({
        label: "Cutback",
        meta: { phase: "cutback" },
      });
      buildCounter = 1; // reset cycle
      continue;
    }

    labels.push({
      label: `Build ${buildCounter}`,
      meta: { phase: "build" },
    });

    buildCounter++;
  }

  return labels;
}
